module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"groupForecaster":"Forecast demand","priceManager":"Dynamic Pricing","menuManager":"Smart Menu","outOfMenu":"Out-of-menu products"},"es":{"groupForecaster":"Previsión de demanda","priceManager":"Dynamic Pricing","menuManager":"Smart Menu","outOfMenu":"Productos fuera de menu"}}')
  delete Component.options._Ctor
}
